import { supabase } from './supabaseClient';

/**
 * Creates a default anonymous profile for a new user.
 * @param {string} userId - The Supabase Auth user ID.
 */
const profiles_table_name = 'ml_profiles_staging';

export async function createDefaultProfile(userId) {
  if (!userId) return;
  const { error } = await supabase.from(profiles_table_name).insert([
    {
      user_id: userId,
      name: 'Anonymous',
      age: null,
      education_level: 'Undergraduate',
      preferred_learning_style: 'Unknown',
      career_goals: 'Unknown',
      languages_spoken: ['Unknown'],
      interests: ['Unknown'],
      certifications: ['None'],
    },
  ]);
  if (error) {
    // eslint-disable-next-line no-console
    console.error('Error creating default profile:', error);
  }
}
